export default "__VITE_ASSET__DDseKwMb__"